export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;

export const PASSWORD_LOWERCASE_REGEX = /\p{Ll}/u;
export const PASSWORD_UPPERCASE_REGEX = /\p{Lu}/u;

export const PASSWORD_PATTERN: RegExp = /^(?=.*\p{Ll})(?=.*\p{Lu}).{8,20}$/u;

export const PASSWORD = 'password';
export const CONFIRM_PASSWORD = 'confirmPassword'
